import * as busyCounter from '../../../../sharedmodules/action-creators/busy-counter';
import actions from '../../../../sharedmodules/actions-list';
import { handleError } from '../../../../sharedmodules/services/error-handlers';
import { searchUserDealerMapping } from '../repositories/searchUserDealerMapping';

export const searchUserDealerMappedData = (getAccessToken, data) => async (dispatch) => {

    dispatch(busyCounter.increaseBusyCounter());

    try {

        const userDealerMappedData = await searchUserDealerMapping(getAccessToken, data);
        dispatch({
            data: userDealerMappedData,
            type: actions.GET_USER_DEALER_MAPPED_DATA,

        });

    } catch (error) {

        handleError(error);

    } finally {

        dispatch(busyCounter.decreaseBusyCounter());

    }

};
